<!-- access-denied.component.html -->
<div class="container">
  <div class="content">
    <h1>Access Denied</h1>
    <p>You do not have permission to view this page.</p>
    <a routerLink="/home">Go back to home</a>
  </div>
</div>
